// Theo dõi video ĐÃ XEM trên Reels (lưu localStorage) để: (1) lọc video đã xem ra khỏi feed,
// (2) chặn lặp — mỗi video xuất hiện tối đa 2 lần (chỉ lặp khi quá ít video).
const KEY = 'reelsSeenVideos';
export const MAX_SHOW = 2; // 1 video hiện tối đa 2 lần

type SeenMap = Record<string, number>;

const load = (): SeenMap => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '{}');
  } catch {
    return {};
  }
};

export const getSeen = (): SeenMap => load();

export const markVideoSeen = (id: string) => {
  if (!id) return;
  const m = load();
  m[id] = (m[id] || 0) + 1;
  try {
    localStorage.setItem(KEY, JSON.stringify(m));
  } catch {
    // localStorage đầy/không dùng được → bỏ qua
  }
};
